<template>
  <div class="props-img-wrap">
    <img :src="imgName(propType)" v-bind="$attrs" />
  </div>
</template>

<script>
const propsMap = {
  0: 'coins',
  1: 'chat-pass',
  2: 'video-pass',
  4: 'vip',
  6: 'call-pass',
  9: 'coupon',
  15: 'super-chat-pass',
}
export default {
  props: {
    propType: {
      type: Number || String,
      default: -1,
    },
    // width: {
    //   type: Number,
    //   default: 20
    // },
    // height: {
    //   type: Number,
    //   default: 20
    // }
  },
  methods: {
    imgName(type) {
      let resImg = ''
      if (propsMap[type]) {
        resImg = this.getMatchImg(propsMap[type])
      }
      //
      else {
        resImg = this.getMatchImg('chat-pass')
      }
      return resImg
    },
  },
}
</script>

<style lang="css" scoped>
.props-img-wrap {
  font-size: 0;
}
</style>
